import {
  CANCEL_MEMBER_REQUEST_ERROR,
  CANCEL_MEMBER_REQUEST_START,
  CANCEL_MEMBER_REQUEST_SUCCESS,
} from 'constants/action-types/groups/cancelMemberRequest';

export default (state, { type, payload }) => {
  switch (type) {
    case CANCEL_MEMBER_REQUEST_START:
      return {
        ...state,
        groupActivities: {
          ...state.groupActivities,
          cancelMemberRequest: {
            loading: true,
            error: null,
            message: null,
          },
        },
      };
    case CANCEL_MEMBER_REQUEST_ERROR:
      return {
        ...state,
        groupActivities: {
          ...state.groupActivities,
          cancelMemberRequest: {
            ...state.groupActivities?.cancelMemberRequest,
            error: payload,
            loading: false,
          },
        },
      };
    case CANCEL_MEMBER_REQUEST_SUCCESS:
      return {
        ...state,
        groupActivities: {
          ...state.groupActivities,
          cancelMemberRequest: {
            ...state.groupActivities?.cancelMemberRequest,
            loading: false,
            message: payload,
          },
        },
      };
    default:
      return null;
  }
};
